import { useQuery } from '@tanstack/react-query';
import { fxRatesService } from '@/services/fx-rates/fx-rates-service';
import { queryKeys } from '@/services/query-keys';

/** One pair's COB (T-1) rate. Disabled until both currencies are known and differ. */
export const useCobFxPair = (fromCurrency: string | undefined, toCurrency: string | undefined) => {
  const from = (fromCurrency || '').toUpperCase();
  const to = (toCurrency || '').toUpperCase();
  return useQuery({
    queryKey: queryKeys.fxRates.cobPair(from, to),
    queryFn: () => fxRatesService.getCobPair(from, to),
    enabled: !!from && !!to && from !== to,
    staleTime: 60 * 60 * 1000, // COB only changes at the daily rollover
    refetchOnWindowFocus: false,
  });
};
